<template>
	<div>
		<div class="top_empty"></div>
		<div style="position: relative">
			<img
				loading="lazy"
				style="width: 100vw; height: 40vw"
				src="../../assets/images/home_top_backimg01.png"
			/>

			<div class="home_topcontent_plate">
				<div class="common_layout" style="position: relative">
					<img
						loading="lazy"
						style="width: 80vw; max-width: 1280px"
						src="../../assets/images/home_top_backimg02.png"
					/>

					<div class="home_top_part">
						<div class="home_top_content">
							<div class="wow animate__fadeInRightBig animate__animated">
								<p class="home_top_english_text">Dedicated to technical</p>
								<p class="home_top_english_text">services</p>
								<div class="blue_line"></div>
								<p class="top_descrip_text">APP开发 · 小程序开发 · H5开发 · 网站开发</p>
							</div>

							<div
								@click="contactWe()"
								class="contact_button center_flex_layout wow animate__fadeInUpBig animate__animated"
							>
								联系我们
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--我们的服务-->
		<div class="our_service_part">
			<div class="common_layout">
				<div class="wow animate__slideInDown animate__animated">
					<div class="center_flex_layout title_text_top">
						<img loading="lazy" src="../../assets/images/our_service_backtext.png" />
					</div>

					<div class="center_flex_layout" style="margin-top: -40px">
						<p class="requirement_title">我们的服务</p>
					</div>

					<p class="line_introduc_text">
						根据需求进行定制，专注于为客户提供高于行业的移动互联网软件定制开发服务
					</p>
				</div>

				<div class="center_flex_layout service_type_top">
					<div
						class="center_flex_layout wow animate__fadeIn animate__animated animate__delay-1s"
						style="flex-flow: row wrap"
					>
						<div
							v-for="(serviceData, index) in serviceArray"
							:key="index"
							class="service_type_plate"
							@click="toService"
						>
							<img
								loading="lazy"
								class="service_type_img"
								:style="{ height: index === 0 ? '132px' : '129px' }"
								:src="serviceData.img"
							/>
							<p class="service_type_title">{{ serviceData.name }}</p>
							<p class="service_type_miaoshu">{{ serviceData.enName }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--项目定制管理流程-->
		<div style="background: #ffffff">
			<div class="common_layout">
				<div
					class="wow animate__slideInDown animate__animated"
					style="position: relative; z-index: 2"
				>
					<div class="center_flex_layout title_text_top">
						<img loading="lazy" src="../../assets/images/project_backtext.png" />
					</div>

					<div class="center_flex_layout" style="margin-top: -40px">
						<p class="requirement_title">项目定制管理流程</p>
					</div>

					<p class="line_introduc_text">
						我们为您配备专业、负责的项目团队成员，严格把控开发质量和项目进度。
					</p>
				</div>
			</div>

			<div class="center_flex_layout project_backimg">
				<img
					class="project_map_backimg"
					loading="lazy"
					src="../../assets/images/home_xiangmudingzhi01.png"
				/>

				<div class="project_content_plate">
					<div class="project_mainimages_plate">
						<div class="center_flex_layout wow animate__zoomIn animate__animated">
							<img
								class="project_mainimages_first"
								loading="lazy"
								src="../../assets/images/home_xiangmudingzhi02.png"
							/>
						</div>
					</div>

					<div class="project_mainimages_plate">
						<div class="center_flex_layout wow animate__zoomIn animate__animated animate__delay-1s">
							<img
								class="project_mainimages_second"
								loading="lazy"
								src="../../assets/images/home_xiangmudingzhi03.png"
							/>
						</div>
					</div>

					<div class="project_mainimages_plate">
						<div class="center_flex_layout wow animate__zoomIn animate__animated animate__delay-2s">
							<img
								class="project_mainimages_thirth"
								loading="lazy"
								src="../../assets/images/home_xiangmudingzhi04.png"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--技术服务-->
		<div style="position: relative">
			<img class="tech_backimg" loading="lazy" src="../../assets/images/tech_plate_backimg.png" />

			<div class="tech_content_plate">
				<div class="common_layout">
					<div class="wow animate__slideInDown animate__animated">
						<div class="center_flex_layout title_text_top">
							<img loading="lazy" src="../../assets/images/tech_serve_backtext.png" />
						</div>

						<div class="center_flex_layout" style="margin-top: -40px">
							<p class="requirement_title">技术服务</p>
						</div>
					</div>

					<div class="center_flex_layout wow animate__fadeInRightBig animate__animated">
						<img
							class="tech_content_line_image"
							loading="lazy"
							src="../../assets/images/jishu_line_title_img.png"
						/>
					</div>

					<div
						class="center_flex_layout tech_servicetype_imageplate wow animate__fadeInLeftBig animate__animated"
					>
						<div class="center_flex_layout tech_servicetype_image">
							<img src="../../assets/images/tech_type_image01.png" />
						</div>

						<div class="center_flex_layout tech_servicetype_image">
							<img src="../../assets/images/tech_type_image02.png" />
						</div>

						<div class="center_flex_layout tech_servicetype_image">
							<img src="../../assets/images/tech_type_image03.png" />
						</div>

						<div class="center_flex_layout tech_servicetype_image">
							<img src="../../assets/images/tech_type_image04.png" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<RequireMent />

		<!--项目需求弹窗-->
		<div class="contact_pop center_flex_layout">
			<div class="total_contact_pop wow animate__bounceIn animate__animated">
				<div class="pop_top_plate">
					<div style="position: relative; z-index: 2">
						<p class="contact_pop_title">请您填写项目需求</p>

						<p class="contact_pop_line">我们提供专业的APP、小程序、H5、网站等定制开发</p>
					</div>

					<div class="pop_close_icon" @click="closePop">
						<img style="width: 100%; height: 100%" src="../../assets/images/pop_close_icon.png" />
					</div>
				</div>

				<div class="center_flex_layout">
					<input v-model="nameVal" class="contact_pop_input" placeholder="姓名" />
				</div>

				<div class="center_flex_layout">
					<input v-model="contactVal" class="contact_pop_input" placeholder="联系方式" />
				</div>

				<div class="center_flex_layout">
					<input
						v-model="contentVal"
						class="contact_pop_input"
						placeholder="请描述您的需求，如：APP开发、小程序开发、H5、网站开发等。"
					/>
				</div>

				<div class="center_flex_layout">
					<div class="center_flex_layout pop_code_image_plate">
						<input v-model="imageCodeVal" class="code_image_input" placeholder="验证码" />

						<div class="code_image center_flex_layout" @click="getImageCode()">
							<img id="popCodeImage" :src="imageCodeUrl" />
						</div>
					</div>
				</div>

				<div class="center_flex_layout">
					<div @click="submitRequire()" class="requirement_submit_button">提交</div>
				</div>

				<p class="contact_pop_bottom_text">* 您填写需求后，我们会尽快与您取得联系 *</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import WOW from "wow.js";
import { post, get } from "../../utils/request.ts";
import axios from "axios";
const { proxy } = getCurrentInstance();
import { useRouter } from "vue-router";
const router = useRouter();

const serviceArray = ref([
	{
		name: "APP定制开发",
		enName: "APP Development",
		img: require("../../assets/images/our_service_type01.png"),
	},
	{
		name: "小程序定制开发",
		enName: "MP Development",
		img: require("../../assets/images/our_service_type02.png"),
	},
	{
		name: "H5定制开发",
		enName: "H5 Development",
		img: require("../../assets/images/our_service_type03.png"),
	},
	{
		name: "网站定制开发",
		enName: "Web Development",
		img: require("../../assets/images/our_service_type04.png"),
	},
]);
const nameVal = ref("");
const contactVal = ref("");
const contentVal = ref("");
const imageCodeVal = ref("");
const imageCodeUrl = ref("");
const uuidVal = ref("");

onMounted(() => {
	wowAnimated();
	uuidVal.value = getUid();
	if (uuidVal.value) {
		getImageCode();
	}
});

const contactWe = () => {
	let contactPop = document.getElementsByClassName("contact_pop")[0];
	contactPop.style.display = "flex";
};

const closePop = () => {
	let contactPop = document.getElementsByClassName("contact_pop")[0];
	contactPop.style.display = "none";
};

const wowAnimated = () => {
	let wow = new WOW({
		boxClass: "wow", // default
		animateClass: "animate__animated", // default
		offset: 0, // default
		mobile: true, // default
		live: true, // default
	});
	wow.init();
};

const toService =()=> {
    router.push("service");
    window.scrollTo(0, 0);
};

const getUid = () => {
	function S4() {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}
	return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
};

const getImageCode = () => {
	axios({
		method: "get",
		url: "https://test.orotalive.com:8200/image/code?cookie=" + uuidVal.value,
		responseType: "arraybuffer",
		headers: {
			withCredentials: true,
		},
	})
		.then((res) => {
			// console.log(res);
			let thisImg = window.URL.createObjectURL(new Blob([res.data], { type: "image/jpeg" }));

			imageCodeUrl.value = thisImg;
		})
		.catch((error) => {
			console.log(error);
		});
};

const submitRequire = () => {
	let submitUrl = "https://test.orotalive.com:8200/official/submit/require";

	if (!nameVal.value) {
		proxy.$toast("请输入您的姓名");
		return;
	}

	if (!contactVal.value) {
		proxy.$toast("请输入您的联系方式");
		return;
	}

	if (!contentVal.value) {
		proxy.$toast("请输入您的需求");
		return;
	}

	if (!imageCodeVal.value) {
		proxy.$toast("请输入验证码");
		return;
	}

	let paramsUrl =
		submitUrl +
		"?name=" +
		nameVal.value +
		"&mobile=" +
		contactVal.value +
		"&require=" +
		contentVal.value +
		"&imageCode=" +
		imageCodeVal.value +
		"&cookie=" +
		uuidVal.value;
	axios({
		method: "post",
		url: paramsUrl,
		headers: {
			withCredentials: true,
		},
	})
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.data.code === 1) {
				proxy.$toast("提交成功");
                nameVal.value = '';
                contactVal.value = '';
                contentVal.value = '';
                imageCodeVal.value = '';
				closePop();
			} else {
				proxy.$toast(res.data.message);
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
</script>

<style lang="less" scoped>
.top_empty {
	width: 100%;
	height: 72px;
	display: none;

	@media screen and (max-width: 899px) {
		display: block;
	}
}

.home_topcontent_plate {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;

	.home_top_part {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;

		.home_top_content {
			width: 1160px;
			margin: 0 auto;
			margin-top: 140px;

			@media screen and (max-width: 1279px) {
				width: 90%;
				margin-top: 100px;
			}

			@media screen and (max-width: 899px) {
				margin-top: 10px;
			}

			.home_top_english_text {
				font-size: 44px;
				color: #102d4d;
				font-weight: bold;

				@media screen and (max-width: 1279px) {
					font-size: 34px;
				}

				@media screen and (max-width: 899px) {
					font-size: 18px;
				}
			}

			.blue_line {
				width: 88px;
				height: 4px;
				background: #12b1f9;
				margin-top: 25px;

				@media screen and (max-width: 1279px) {
					width: 68px;
					margin-top: 20px;
				}

				@media screen and (max-width: 899px) {
					width: 44px;
					height: 2px;
					margin-top: 5px;
				}
			}

			.top_descrip_text {
				font-size: 20px;
				color: #102d4d;
				margin-top: 40px;

				@media screen and (max-width: 1279px) {
					font-size: 16px;
					margin-top: 30px;
				}

				@media screen and (max-width: 899px) {
					font-size: 14px;
					margin-top: 10px;
				}
			}

			.contact_button {
				width: 159px;
				height: 48px;
				border-radius: 200px;
				background: rgb(18, 177, 249);
				font-size: 14px;
				color: #ffffff;
				box-shadow: 0px 5px 7px rgba(18, 177, 249, 0.32);
				transition: all 0.3s;
				cursor: pointer;
				margin-top: 50px;

				&:hover {
					box-shadow: none;
				}

				@media screen and (max-width: 1279px) {
					margin-top: 30px;
				}

				@media screen and (max-width: 899px) {
					width: 100px;
					height: 30px;
					margin-top: 10px;
				}
			}
		}
	}
}

.our_service_part {
	width: 100%;
	/*height: 588px;*/
	background: rgb(238, 246, 250);
	margin-top: -8px;

	.service_type_plate {
		padding: 30px 20px;
		background: #ffffff;
		border-radius: 10px;
		border: 1px solid #ecf3f6;
		transition: all 0.3s;
		cursor: pointer;
		margin: 0 30px;
		margin-top: 30px;

		&:hover {
			transform: translateY(-5px);
			box-shadow: 0 15px 30px rgba(18, 177, 249, 0.15);
		}

		.service_type_img {
			width: 137px;
			height: 129px;

			@media screen and (max-width: 1279px) {
				transform: scale(0.9);
			}

			@media screen and (max-width: 899px) {
				transform: scale(0.7);
			}
		}

		.service_type_title {
			font-size: 16px;
			font-weight: bold;
			color: #102d4d;
			text-align: center;
			margin-top: 20px;

			@media screen and (max-width: 1279px) {
				margin-top: 10px;
			}

			@media screen and (max-width: 899px) {
				font-size: 14px;
			}
		}

		.service_type_miaoshu {
			font-size: 12px;
			color: #cccccc;
			text-align: center;
			margin-top: 5px;

			@media screen and (max-width: 1279px) {
				margin-top: 2px;
			}
		}

		@media screen and (max-width: 1279px) {
			padding: 20px 15px;
			margin: 0 20px;
			margin-top: 20px;
		}

		@media screen and (max-width: 899px) {
			padding: 15px 10px;
			margin: 0 10px;
			margin-top: 15px;
		}
	}
}

.line_introduc_text {
	font-size: 16px;
	color: #58687b;
	text-align: center;
	margin-top: 20px;
	position: relative;
	z-index: 2;

	@media screen and (max-width: 899px) {
		font-size: 12px;
		margin: 0 20px;
		margin-top: 15px;
	}
}

.service_type_top {
	margin-top: 50px;
	padding-bottom: 80px;

	@media screen and (max-width: 899px) {
		margin-top: 0;
		padding-bottom: 30px;
	}
}

.project_backimg {
	width: 80vw;
	/*height: 40vw;*/
	margin: 0 auto;
	margin-top: -90px;
	padding-bottom: 10px;
	position: relative;

	.project_map_backimg {
		width: 100%;
		height: 100%;

		@media screen and (max-width: 899px) {
			opacity: 0;
		}
	}

	@media screen and (max-width: 899px) {
		width: 100vw;
		padding-bottom: 200px;
	}
}

.project_content_plate {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;

	.project_mainimages_plate {
		position: absolute;
		width: 100%;
		top: 120px;

		@media screen and (max-width: 1279px) {
			top: 80px;
		}

		@media screen and (max-width: 599px) {
			top: 120px;
		}

		.project_mainimages_first {
			width: 40%;

			@media screen and (max-width: 599px) {
				width: 65%;
			}
		}

		.project_mainimages_second {
			width: 35%;
			margin-top: 35px;

			@media screen and (max-width: 599px) {
				width: 60%;
				margin-top: 10px;
			}
		}

		.project_mainimages_thirth {
			width: 55%;
			margin-top: 35px;

			@media screen and (max-width: 599px) {
				width: 90%;
				margin-top: 10px;
			}
		}
	}
}

.tech_backimg {
	width: 100%;
	max-height: 594px;

	@media screen and (max-width: 899px) {
		display: none;
	}
}

.tech_content_plate {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;

	@media screen and (max-width: 899px) {
		position: relative;
		background: #eef6fa;
	}

	.tech_content_line_image {
		transform: scale(0.7);
		margin-top: 10px;

		@media screen and (max-width: 1279px) {
			transform: scale(0.6);
			margin-top: 0;
		}

		@media screen and (max-width: 899px) {
			transform: scale(0.4);
			margin-top: -10px;
		}
	}

	.tech_servicetype_imageplate {
		width: 75%;
		margin: 0 auto;
		margin-top: 30px;
		padding-bottom: 60px;

		@media screen and (max-width: 899px) {
			width: 100%;
			flex-flow: row wrap;
			margin-top: -20px;
		}
	}

	.tech_servicetype_image {
		width: 25%;

		@media screen and (max-width: 899px) {
			width: 50%;
			margin-top: 20px;
		}

		img {
			width: 80%;
			box-shadow: 0 15px 30px rgba(18, 177, 249, 0.15);
		}
	}
}

.contact_pop {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: rgba(168, 200, 213, 0.75);
	z-index: 1002;
	display: none;

	.total_contact_pop {
		width: 40%;
		border-radius: 6px;
		overflow: hidden;
		background: #ffffff;

		@media screen and (max-width: 599px) {
			width: 80%;
		}

		.pop_top_plate {
			padding: 30px 0;
			background: #ffffff;
			position: relative;
			margin-top: -5px;

			@media screen and (max-width: 599px) {
				padding: 20px 0;
				margin-top: 0;
			}

			&:after {
				content: "";
				width: 100%;
				height: 100%;
				background-image: url("../../assets/images/pop_top_backimg.png");
				background-repeat: no-repeat;
				background-size: 100%;
				position: absolute;
				top: 0;
				left: 0;
			}

			.contact_pop_title {
				font-size: 26px;
				color: #ffffff;
				text-align: center;

				@media screen and (max-width: 599px) {
					font-size: 18px;
				}
			}

			.contact_pop_line {
				font-size: 14px;
				color: #a4e5f2;
				text-align: center;
				margin-top: 25px;

				@media screen and (max-width: 599px) {
					font-size: 12px;
					margin-top: 15px;
				}
			}

			.pop_close_icon {
				width: 15px;
				height: 15px;
				position: absolute;
				top: 20px;
				right: 15px;
				z-index: 2;
				cursor: pointer;

				@media screen and (max-width: 599px) {
					top: 10px;
					right: 10px;
				}
			}
		}

		.contact_pop_input {
			width: 60%;
			padding: 7px 12px;
			border: 1px #ebeef3 solid;
			margin-top: 12px;
			border-radius: 4px;
			font-size: 14px;
			color: #000000;

			@media screen and (max-width: 599px) {
				width: 70%;
			}
		}

		.pop_code_image_plate {
			width: 60%;
			padding: 0 12px;
			border-radius: 4px;
			border: 1px #ebeef3 solid;
			background-color: #ffffff;
			margin-top: 12px;
			overflow: hidden;

			@media screen and (max-width: 599px) {
				width: 70%;
			}

			.code_image_input {
				flex: 1;
				border: none;
				font-size: 14px;
				color: #000000;
			}

			.code_image {
				padding: 5px 0;
				padding-left: 12px;
				height: 100%;
				border-left: 1px #ebeef3 solid;
				cursor: pointer;
			}
		}

		.requirement_submit_button {
			width: 100px;
			padding: 7px 0;
			border-radius: 4px;
			background: #12b1f9;
			font-size: 14px;
			font-weight: 400;
			color: #ffffff;
			text-align: center;
			cursor: pointer;
			margin-top: 10px;

			&:hover {
				opacity: 0.8;
			}
		}

		.contact_pop_bottom_text {
			font-size: 12px;
			color: #bbbbbb;
			margin: 20px 0;
			text-align: center;
		}
	}
}
</style>
